module.exports = __webpack_public_path__ + "static/media/4ll11.450cac6a.png";